import { render } from "./EventList.vue?vue&type=template&id=ecdae83a&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=ecdae83a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ecdae83a"

export default script